import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function TopBar() {
  return <header className="sticky top-0 z-50 border-b border-orange-100 bg-white/95 shadow-sm backdrop-blur" data-id="element-306" data-mp="232nfsn0fptzi">
      <div className="bg-primary px-3 py-1.5 text-center font-display text-[10px] font-bold tracking-wide text-white sm:text-xs md:text-sm" data-id="element-307" data-mp="1y4vex3htaxj6">
        🇦🇷 Sistema N°1 para Profesionales que Trabajan con Adultos Mayores en Argentina
      </div>
      <div className="mx-auto hidden max-w-5xl items-center justify-center gap-7 py-2 text-xs font-medium text-slate-500 md:flex" data-id="element-308" data-mp="2qukedcevipio">
        <span className="flex items-center gap-1.5" data-id="element-309" data-mp="2h24z4muyof1h">
          <ZapIcon className="h-3.5 w-3.5 text-accent" data-id="element-310" data-mp="2h0txotoznjdj" /> Acceso en 5 minutos
        </span>
        <span className="text-orange-300" data-id="element-311" data-mp="2c3231rwylj5n">·</span>
        <span className="flex items-center gap-1.5" data-id="element-312" data-mp="39ipiikzg0ci0">
          <LockIcon className="h-3.5 w-3.5 text-accent" data-id="element-313" data-mp="39ka9y1qgnfbn" /> Pago seguro
        </span>
        <span className="text-orange-300" data-id="element-314" data-mp="34rh8pnu7ap4b">·</span>
        <span className="flex items-center gap-1.5" data-id="element-315" data-mp="257xabldlhj1">
          <ShieldCheckIcon className="h-3.5 w-3.5 text-accent" data-id="element-316" data-mp="25rbbh7wnlrs" /> Garantía de 7 días
        </span>
      </div>
    </header>;
}